export default __webpack_public_path__ + "images/besafer_logo.png";